import debounce from "lodash.debounce";
import React, { ChangeEvent, useState } from "react";
import RichTextTranslator from "../../Logic/RichTextTranslator";
import { validateLink } from "../../Logic/utils";
import { CompleteEditor } from "../Molecule/MinimalEditor";
import { ElementType, TextElement } from "types/types";
import { JSONContent } from "@tiptap/react";

/*
  @function ReferenceEditor
  edit reference
  @param text {object} - handles text information
  @param onUpdateStrings {function} - update simple strings
  @param onUpdatdateRichtText {function} - update rich text
*/
export default function ReferenceEditor({
  text,
  onUpdateStrings,
  onUpdateRichText,
}: {
  text?: {
    name: string;
    description?: TextElement;
    reference_id?: string;
    code?: string;
    link?: string;
  };
  onUpdateStrings: (
    v: ChangeEvent<HTMLInputElement>,
    key: string,
    type: string,
    id: string
  ) => void;
  onUpdateRichText: (
    v: JSONContent,
    key: string,
    type: string,
    id: string
  ) => void;
}) {
  const [validation, setValidation] = useState({ link: false });

  const description =
    text?.description && typeof text.description === "string"
      ? JSON.parse(text.description)
      : text?.description !== undefined
      ? text.description
      : {};

  if (text && text.reference_id === undefined) {
    text.reference_id = "";
  }

  return (
    <>
      <label className="text-center m-2">Code</label>
      <input
        type="text"
        id="code"
        name="first"
        defaultValue={text?.code ? text.code : ""}
        className="border border-2 border-black m-6"
        onChange={debounce((v: ChangeEvent<HTMLInputElement>) =>
          onUpdateStrings(
            v,
            "code",
            ElementType.Reference,
            text?.reference_id !== undefined ? text.reference_id : ""
          )
        )}
      />
      <label className="text-center m-2">Link</label>
      <input
        type="text"
        id="link"
        name="first"
        defaultValue={text?.link ? text.link : ""}
        className="border border-2 border-black m-6"
        onChange={debounce((v: ChangeEvent<HTMLInputElement>) => {
          setValidation({ ...validation, link: validateLink(v.target.value) });

          onUpdateStrings(
            v,
            "link",
            ElementType.Reference,
            text?.reference_id !== undefined ? text.reference_id : ""
          );
        })}
      />
      {!validation.link && (
        <label className="text-center mb-2 text-rose-900">not valid</label>
      )}
      <label className="text-center m-2 ">Reference description</label>
      <CompleteEditor
        className="border border-2 border-black m-6 h-64"
        onUpdate={(v) =>
          onUpdateRichText(
            v,
            "description",
            ElementType.Reference,
            text?.reference_id !== undefined ? text.reference_id : ""
          )
        }
        text={
          "text" in description
            ? {
                type: "doc",
                content: RichTextTranslator({ text: description.text }),
              }
            : description
        }
        elementAskingRerender={[]}
        element={{ reference: text?.reference_id }}
      />
    </>
  );
}
